import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'ramda';

import styleFile from './RoomPreference.js';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import RichText from '@synergycms_core/components/generic/RichText';
import SelectField from '@synergycms_core/components/generic/Form/SelectField.jsx';
import roomPreferenceStyles from './styles';
import { withThemeJSS } from 'synergycms_core/src/components/providers/themeProvider';

const RoomPreferenceOption = (preference, classes) => props => {
  return (
    <div {...props.innerProps} className={classes.textContainer}>
      <div className={classes.nameType}>
        <RichText innerStyle={['roboto13Gray']} text={preference.get('name')} />
      </div>
      <div className={[classes.padded].join(' ')}>
        <RichText innerStyle={['roboto13Black']} text={props.data.get('description')} />
      </div>
    </div>
  );
};

class RoomPreference extends React.Component {
  static displayName = 'RoomPreference';
  render() {
    const { preference, optionId, blockIdx } = this.props.config;
    const model = 'room_preference_' + preference.get('id') + (blockIdx ? `-${blockIdx}` : '');
    const { theme } = this.props;
    const { classes } = theme.styles;
    return (
      <SelectField
        getOptionLabel={option => option.get('description')}
        getOptionValue={option => option.get('id')}
        defaultValue={preference.get('options').find(option => option.get('id') === optionId)}
        model={model}
        placeholder={""}
        options={preference.get('options')}
        isSearchable={false}
        components={{
          SingleValue: RoomPreferenceOption(preference, classes)
        }}
        styles={roomPreferenceStyles({mainColor: theme.themeValues.mainColor})}
        label={'preferences'}
      />
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {};
};

const mapStateToProps = (store, ownProps) => {
  return {};
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  PropertyManager(['preference', 'optionId', 'blockIdx']),
  withThemeJSS({ styleFile, link: true })
)(RoomPreference);
